import { Component, Inject, OnInit, Output, EventEmitter, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, Location } from '@angular/common';

import { CategoryService } from 'lib/services/category/category.service';
import { RouterService } from 'lib/services/router.service';

@Component({
    selector: 'app-category-pagination',
    templateUrl: './category-pagination.component.html',
    styleUrls: ['./category-pagination.component.scss'],
    standalone: false,
})
export class CategoryPaginationComponent implements OnInit {
    @Output() pageChanged = new EventEmitter<void>();
    isBrowser: boolean;

    constructor(
        @Inject(PLATFORM_ID) private platformId: Object,
        private categoryService: CategoryService,
        private routerService: RouterService,
        private location: Location
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    ngOnInit() {}

    get pagination() {
        return this.categoryService.category.pagination;
    }
    get urlComponent() {
        return this.routerService.url.component;
    }

    paginate(paramObj: any) {
        if (!this.isBrowser) {
            return;
        }
        let url = window.location.pathname;
        const searchParams = new URLSearchParams();
        Object.keys(paramObj).forEach((param) => {
            searchParams.set(param, paramObj[param]);
        });
        if (searchParams.toString()) {
            url += '?';
        }
        url += decodeURIComponent(searchParams.toString());
        this.location.go(url);

        // Wait for loadPage to complete before emitting event
        this.categoryService.loadPage().then(() => {
            setTimeout(() => this.pageChanged.emit(), 50);
        });

        const categoryBody = document.getElementById('category-body');
        categoryBody.scrollIntoView({
            behavior: 'smooth',
        });
    }
}
